import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import styles from './MapLoading.module.scss';
const MapLoading = () => {
  return <Box className={styles['map-loading-container']} data-sentry-element="Box" data-sentry-component="MapLoading" data-sentry-source-file="MapLoading.tsx">
      <Box className={styles['loading-icon']} data-sentry-element="Box" data-sentry-source-file="MapLoading.tsx">
        <Icon name="location-Filled" type="primary" size={50} data-sentry-element="Icon" data-sentry-source-file="MapLoading.tsx" />
      </Box>
    </Box>;
};
export default MapLoading;